// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_83895b49","dialog":"_0c687eda","active":"_8e78e12f","small":"_8f312f8d","normal":"_3c5c3e8d","large":"_727468b2","fullscreen":"_26758518","title":"_7971d262","body":"f7f3fd3d","navigation":"_6742d89b","button":"_4bb9d825"};


//////////////////
// WEBPACK FOOTER
// ./~/react-toolbox/lib/dialog/theme.css
// module id = 5255
// module chunks = 39